import { API } from "./axiosInstance"

/**
 * Gets all the members from usermanagement-service
 * @returns the members
 */
 export const getEmpowerableMembers = async () => {
    const empowerableMembers = await API.get(`/empowerableMembers`);
    return empowerableMembers.data;
  }

/**
 * Gets all the members from usermanagement-service
 * @returns the members
 */
export const getMembers = async () => {
  const members = await API.get(`/members`);
  return members.data;
}

/**
 * Gets one member
 * @param {*} staticId the id of the static member to get
 * @returns the member
 */
export const getOne = async (staticId) => {
    const member = await API.get(`/members/${staticId}`);
    return member.data;
}

/**
 * Gets members based on the provided query object. The query
 * object is transformed into an URL query string.
 * @param {*} query an object containing query parameters
 * Example query object
 * {
 *     name: testmember,
 *     ...,
 *     param: value
 * }
 * @returns an array of members
 */
export const getMembersByQuery = async (query) => {

    let queryString = Object.keys(query).map(function (key) {
        return "" + key + "=" + encodeURIComponent(query[key]);
    }).join("&");

    const member = await API.get(`/members?` + queryString);
    return member.data;
}

/**
 * Creates one member by calling the usermanagement-service endpoint
 * @param {*} member the member to created
 * @returns the created member
 */
export const create = async (member) => {
    const response = await API.post(`/members`, member);
    return response.data;
  }

/**
 * Gets the applications of a member and include all
 * @param {*} staticId the id of the static member to get
 * @returns the members and its joined objects
 */
export const getApplicationsFromMember = async (staticId) => {
    const members = await API.get(`/members/${staticId}/applications`);
    return members.data;
}

/**
 * Links the applications to the member
 * @param {*} staticId the id of the member to get
 * @returns the members and its joined objects
 */
export const postApplicationOnMember = async (staticId, applicationMember) => {
    const members = await API.post(`/members/${staticId}/applications`, applicationMember);
    return members.data;
}

/**
 * Updates one member by calling the usermanagement-service endpoint
 * @param {*} member the member to updated
 * @param {*} staticId the staticId of the member
 * @returns the updated member
 */
export const updateMember = async(member, staticId) => {
    const response = await API.put(`/members/${staticId}`, member);
    return response.data;
}

/**
 * Accepts a requested change for a member
 * @param {*} staticId the id of the member in the static model
 * @returns the accepted member
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/members/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a member
 * @param {*} staticId the id of the member in the static model
 * @returns the rejected member
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/members/${staticId}/reject`);
    return response.data;
}